const WellTypes = {
  CLIENT: 'client',
  PARTNER: 'partner',
  BIG_SCALE_DOWN: 'big-scale-down',
  BIG_CROPPED: 'big-cropped',
  CONSTANT_RELATIVE_WIDTH_AND_HEIGHT: 'constant-relative-width-and-height',
};

module.exports = WellTypes;
